import PropTypes from 'prop-types';
import Icon from '@/components/ui/AppIcon';

export default function PrayerJournalCard({ prayerEntries }) {
  return (
    <div className="bg-card rounded-xl p-6 border border-border hover-lift">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-crimson font-semibold text-foreground">Prayer Journal</h3>
        <Icon name="HeartIcon" size={24} className="text-primary" />
      </div>
      <div className="space-y-3">
        {prayerEntries?.slice(0, 3)?.map((entry) => (
          <div key={entry?.id} className="p-3 bg-surface rounded-lg">
            <div className="flex items-center justify-between mb-2">
              <span className="text-xs font-inter text-muted-foreground">{entry?.date}</span>
              <span className={`text-xs px-2 py-1 rounded-full font-inter ${
                entry?.type === 'gratitude' ? 'bg-success/10 text-success' :
                entry?.type === 'request'? 'bg-primary/10 text-primary' : 'bg-accent/10 text-accent'
              }`}>
                {entry?.type}
              </span>
            </div>
            <p className="text-sm font-source-serif text-foreground line-clamp-2">{entry?.content}</p>
          </div>
        ))}
        
        <button className="w-full mt-4 px-4 py-2 bg-primary text-primary-foreground rounded-lg font-inter font-medium text-sm hover:bg-primary/90 contemplative-transition">
          Add New Entry
        </button>
      </div>
    </div>
  );
}

PrayerJournalCard.propTypes = {
  prayerEntries: PropTypes?.arrayOf(
    PropTypes?.shape({
      id: PropTypes?.number?.isRequired,
      date: PropTypes?.string?.isRequired,
      type: PropTypes?.oneOf(['gratitude', 'request', 'reflection'])?.isRequired,
      content: PropTypes?.string?.isRequired
    })
  )?.isRequired
};